<template>
    <div>
        <BaseMeetingCard ref="baseMeetingCardRef">
            <template #badges>
                <SchedulingStateBadge
                    :entityWithSchedulingState="localMeetingData.meeting"
                />
                <BadgeSeparator />
                <template
                    v-if="localMeetingData.meeting.snapshotIsPaymentRequired"
                >
                    <PaymentStateBadge
                        :entityWithPaymentState="localMeetingData.meeting"
                    />
                    <BadgeSeparator />
                </template>
                <template v-if="localMeetingData.meeting.isRecurring">
                    <IsRecurringMeetingBadge />
                    <BadgeSeparator />
                </template>
                <UniqueCodeBadge
                    :uniqueCode="localMeetingData.meeting.uniqueCode"
                />
            </template>

            <template #visibleDetails>
                <MeetingBasicDetailsSection
                    :meetingData="localMeetingData"
                    :isCardExpanded="baseMeetingCardRef?.isExpanded ?? false"
                    :displayTimezone="displayTimezone"
                />
            </template>

            <template #hiddenDetails>
                <MeetingExtraDetailsSection
                    v-if="baseMeetingCardRef?.isExpanded ?? false"
                    :meetingData="localMeetingData"
                    :companyUser="companyUser"
                    @onToggleNoShowAttendanceSuccess="
                        handleToggleNoShowReservationSuccess($event.meetingData)
                    "
                />
            </template>
        </BaseMeetingCard>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, ref } from 'vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import MeetingBasicDetailsSection from '@/App/Booking/Meeting/Component/MeetingBasicDetailsSection.vue'
    import MeetingExtraDetailsSection from '@/App/Booking/Meeting/Component/MeetingExtraDetailsSection.vue'
    import BaseMeetingCard from '@/App/Booking/Meeting/Component/BaseMeetingCard.vue'
    import type { BaseMeetingCardRefType } from '@/Shared/AutoGenerated/Types'
    import UniqueCodeBadge from '@/App/Booking/Meeting/Component/UniqueCodeBadge.vue'
    import SchedulingStateBadge from '@/App/Booking/Meeting/Component/SchedulingStateBadge.vue'
    import PaymentStateBadge from '@/App/Booking/Meeting/Component/PaymentStateBadge.vue'
    import BadgeSeparator from '@/App/Booking/Meeting/Component/BadgeSeparator.vue'
    import IsRecurringMeetingBadge from '@/App/Booking/Meeting/Component/IsRecurringMeetingBadge.vue'
    import { TimeZoneEnum } from '@/Shared/AutoGenerated/TimeZoneEnum'

    const emits = defineEmits<{
        onError: [{ errorMessage: string | null }]
    }>()

    const props = defineProps({
        meetingData: {
            type: Object as PropType<MeetingData>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            default: null,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            default: false,
        },
        displayTimezone: {
            type: String as PropType<TimeZoneEnum>,
            required: true,
        },
    })

    const localMeetingData = ref<MeetingData>(props.meetingData)
    const baseMeetingCardRef = ref<BaseMeetingCardRefType>(null)

    const handleToggleNoShowReservationSuccess = (meetingData: MeetingData) => {
        localMeetingData.value = meetingData
    }
</script>
